class wgRenderState {
    constructor() {
        this.blendingEnabled_ = false;
        this.cullFaceEnabled_ = false;
        this.depthTestEnabled_ = false;
        this.multiSamplingEnabled_ = false;
        this.scissorTestEnabled_ = false;
        this.stencilTestEnabled_ = false;
        this.polygonFillOffsetEnabled_ = false;
        this.glDebugOutputEnabled_ = false;
        this.pointSize_ = 4.0;
        this.lineWidth_ = 1.0; // line width cannot be larger than 1.0 (at least on nvidia)
    }

    reset() {}

    // texture binds and stuff
}

export { wgRenderState };
